import React, { ReactNode } from 'react';
import cx from 'classnames';

import { ReactComponent as Docs } from 'app/components/svg/Footer/Docs.svg';
import { ReactComponent as Discord } from 'app/components/svg/Footer/Discord.svg';
import { ReactComponent as Reddit } from 'app/components/svg/Footer/Reddit.svg';
import { ReactComponent as Telegram } from 'app/components/svg/Footer/Telegram.svg';
import { ReactComponent as Twitter } from 'app/components/svg/Footer/Twitter.svg';
import { MADFISH, QUIPUSWAP } from 'app/utils/defaults';

import s from './Footer.module.sass';

export type FooterListType = {
  id: number
  Icon: ReactNode
  href: string
};

const footerListMobile = [
  {
    id: 1,
    Icon: <Docs className={cx(s.icon)} />,
    href: 'https://docs.quipuswap.com',
  },
  {
    id: 2,
    Icon: <Twitter className={cx(s.icon)} />,
    href: 'https://twitter.com/madfishofficial',
  }, {
    id: 3,
    Icon: <Telegram className={cx(s.icon)} />,
    href: 'https://t.me/MadFishCommunity',
  }, {
    id: 4,
    Icon: <Discord className={cx(s.icon)} />,
    href: 'https://discord.com/invite/qFRZ8kVzkv',
  }, {
    id: 5,
    Icon: <Reddit className={cx(s.icon)} />,
    href: 'https://www.reddit.com/r/MadFishCommunity/',
  },
] as FooterListType[];

const Footer: React.FC = () => (
  <footer className={cx(s.root)}>
    <div className={cx(s.row)}>
      <a href={QUIPUSWAP} target="_blank" rel="noreferrer" className={cx(s.link)}>
        QuipuSwap.com
      </a>

      <a href={MADFISH} target="_blank" rel="noreferrer" className={cx(s.link)}>
        <span className={cx(s.company)}>Madfish.Solutions</span>
        <span>❤️</span>
      </a>
    </div>

    <div className={cx(s.row)}>
      {footerListMobile.map(({ id, Icon, href }: FooterListType) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noreferrer"
          className={cx(s.socialLink)}
        >
          {Icon}
        </a>
      ))}
    </div>
  </footer>
);

export default Footer;
